import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/Layout.vue'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'question-bank',
        name: 'QuestionBank',
        component: () => import('@/views/QuestionBank.vue'),
        meta: { title: '题库' }
      },
      {
        path: 'mine',
        name: 'Mine',
        component: () => import('@/views/Mine.vue'),
        meta: { title: '我的' }
      },
      {
        path: 'wrong-paper',
        name: 'WrongPaper',
        component: () => import('@/views/WrongPaper.vue'),
        meta: { title: '错题练习' }
      },
      {
        path: 'quick-search',
        name: 'QuickSearch',
        component: () => import('@/views/QuickSearch.vue'),
        meta: { title: '快速搜题' }
      },
      {
        path: 'my-orders',
        name: 'MyOrders',
        component: () => import('@/views/MyOrders.vue'),
        meta: { title: '我的订单' }
      },
      {
        path: 'my-practice',
        name: 'MyPractice',
        component: () => import('@/views/MyPractice.vue'),
        meta: { title: '我的练题' }
      },
      {
        path: 'my-exam',
        name: 'MyExam',
        component: () => import('@/views/MyExam.vue'),
        meta: { title: '我的考试' }
      },
      {
        path: 'my-collection',
        name: 'MyCollection',
        component: () => import('@/views/MyCollection.vue'),
        meta: { title: '我的收藏' }
      }
    ]
  },
  {
    path: '/exam-detail/:paperId',
    name: 'ExamDetail',
    component: () => import('@/views/ExamDetail.vue'),
    meta: { title: '试题详情' }
  },
  {
    path: '/exam/:paperId',
    name: 'Exam',
    component: () => import('@/views/Exam.vue'),
    meta: { title: '模拟考试' }
  },
  {
    path: '/practice/:paperId',
    name: 'Practice',
    component: () => import('@/views/Practice.vue'),
    meta: { title: '章节练习' }
  },
  {
    path: '/result/:paperId',
    name: 'Result',
    component: () => import('@/views/Result.vue'),
    meta: { title: '考试结果' }
  },
  {
    path: '/analysis/:paperId',
    name: 'Analysis',
    component: () => import('@/views/Analysis.vue'),
    meta: { title: '试卷解析' }
  },
  {
    path: '/wrong-book/:id',
    name: 'WrongBook',
    component: () => import('@/views/WrongBook.vue'),
    meta: { title: '错题本' }
  },
  {
    path: '/wrong-detail',
    name: 'WrongDetail',
    component: () => import('@/views/WrongDetail.vue'),
    meta: { title: '错题详情' }
  },
  {
    path: '/wrong-practice/:paperId',
    name: 'WrongPractice',
    component: () => import('@/views/WrongPractice.vue'),
    meta: { title: '错题练习' }
  },
  {
    path: '/quick-practice',
    name: 'QuickPractice',
    component: () => import('@/views/QuickPractice.vue'),
    meta: { title: '快速练习' }
  },
  {
    path: '/my-collection-practice',
    name: 'MyCollectionPractice',
    component: () => import('@/views/MyCollectionPractice.vue'),
    meta: { title: '收藏练习' }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 全局导航守卫：校验登录状态
router.beforeEach((to, from, next) => {
  // 登录页不需要校验
  if (to.path === '/login') {
    next()
    return
  }

  // 检查 localStorage 中是否有 openid
  const openid = localStorage.getItem('openid')
  if (openid) {
    next()
  } else {
    // 没有 openid，跳转登录页
    next('/login')
  }
})

export default router
